import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Row, Col, Card, CardBody,
} from 'reactstrap';
import { MaterialTable } from '@alumni-ventures-group/react-shared/lib/components';
import { uid } from 'react-uid';
import sortByNumberValue from '../../helpers/sortByNumberValue';

const columnTitlesReports = [
  {
    alignment: 'left',
    id: 'reportName',
    label: 'Report Name',
  },
  {
    alignment: 'left',
    id: 'publication_date',
    label: 'Publication Date',
  },
  {
    alignment: 'left',
    id: 'download',
    label: 'File',
    insertRaw: true,
  },
];

const returnReportsDataObject = (reports) => reports.map((report) => ({
  reportName: report.file_display_name,
  fundsList: report.funds.map((fund) => fund.name).join(','),
  publication_date: moment(report.publication_date).format('MMMM DD, YYYY'),
  // eslint-disable-next-line max-len
  download: `<button class="btn btn-primary" onClick="window.open('${report.file_url}')">View</button>`,
}));

const ReportTable = ({ reports }) => (
  <Row key={uid('id')}>
    <Col>
      <Card style={{ paddingTop: '30px' }}>
        <CardBody
          className="pb-1"
          style={{
            // boxShadow: 'rgba(0, 0, 0, 0.04) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
            padding: '8px, 10px',
          }}
        >
          <Row>
            <Col>
              <h4>Investor Reports</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <MaterialTable
                columns={columnTitlesReports}
                dataArray={returnReportsDataObject(reports)}
                preSort={{ field: 'publication_date', order: 'desc' }}
                edit={null}
                rowSize={25}
                selectable={false}
                showToolbar={false}
                wrapHeaders
                customSort={sortByNumberValue}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

ReportTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  reports: PropTypes.any.isRequired,
};

export default ReportTable;
